import SoldOutModalContainer from './SoldOutModalContainer';

export default SoldOutModalContainer;
